module.exports = __webpack_public_path__ + "assets/img/Quorn-Pillar-Page-Resource.2da216cc.jpg";